import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivationEnd } from '@angular/router';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { AccountMenuVersion } from '@frontend/sports/user/feature';
import { HtmlNode, OnAppInit, UserLoginEvent, UserService } from '@frontend/vanilla/core';
import { AccountMenuConfig } from '@frontend/vanilla/shared/account-menu';
import { combineLatest, filter, map, switchMap, take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SettingsService implements OnAppInit {
    private accountMenuConfig = inject(AccountMenuConfig);
    private htmlNode = inject(HtmlNode);
    private routeService = inject(RouterEventsService);
    private userService = inject(UserService);
    private productUtils = inject(SportsProductUtils);

    private readonly destroyRef = inject(DestroyRef);

    onAppInit(): void {
        const routeNavigation$ = this.routeService.currentActivationEnd.pipe(filter((route) => route?.snapshot.data.tag));
        const vanillaAccountVersion$ = this.accountMenuConfig.whenReady.pipe(map(() => this.accountMenuConfig.account.version));

        const accountVersion$ = this.userService.isAuthenticated
            ? vanillaAccountVersion$
            : this.userService.events.pipe(
                  filter((event) => event instanceof UserLoginEvent),
                  take(1),
                  switchMap(() => vanillaAccountVersion$),
              );

        combineLatest([accountVersion$, routeNavigation$])
            .pipe(this.productUtils.filterSportsEmitLast(), takeUntilDestroyed(this.destroyRef))
            .subscribe(([accountVersion, route]) => {
                this.toggleCardLayoutStyle(accountVersion, this.isCardLayoutRoute(route));
            });
    }

    private isCardLayoutRoute(navRoute: ActivationEnd | undefined): boolean {
        return (
            navRoute?.snapshot.data.tag === RouteTag.Settings ||
            navRoute?.snapshot.data.tag === RouteTag.EarlyPayoutSettings ||
            navRoute?.snapshot.data.tag === RouteTag.GeneralBetslipSettings
        );
    }

    private toggleCardLayoutStyle(accountVersion: number, add: boolean) {
        if (accountVersion === AccountMenuVersion.V3) this.htmlNode.setCssClass('navigation-layout-page-card', add);
    }
}
